<template>
    <v-container  class="" style="max-width: 1100px;">
        <v-row justify="center">
            <v-col cols="12" class="text-center mt-8 mb-2">
                <h1 class="font-weight-bold display-1 mb-2" style="font-family: 'Montserrat', sans-serif;">
                    Controles de Formulario
                </h1>
                <div class="subtitle-1 grey--text">
                    Inputs, selects, checkboxes y controles interactivos
                </div>
            </v-col>
        </v-row>

        <v-row>
            <!-- Left Column -->
            <v-col cols="12" md="6">
                <h2 class="font-weight-bold mb-4" style="font-size: 1.5rem;">Campos de Entrada</h2>
                <!-- Email -->
                <v-text-field
                    v-model="email"
                    label="Email"
                    placeholder="usuario@sincarbono.com"
                    outlined
                    dense
                    class="mb-1"
                ></v-text-field>
                <div class="caption grey--text mb-4" style="margin-left: 10px;">
                    Formato de email válido requerido
                </div>
                <!-- Password -->
                <v-text-field
                    v-model="password"
                    :type="showPassword ? 'text' : 'password'"
                    label="Contraseña"
                    outlined
                    dense
                    :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="showPassword = !showPassword"
                    class="mb-4"
                ></v-text-field>
                <!-- Search -->
                <v-text-field
                    v-model="search"
                    label="Búsqueda"
                    placeholder="Buscar proyectos..."
                    outlined
                    dense
                    prepend-inner-icon="mdi-magnify"
                    class="mb-8"
                ></v-text-field>

                <h2 class="font-weight-bold mb-4" style="font-size: 1.5rem;">Selects y Checkboxes</h2>
                <!-- Select -->
                <v-select
                    v-model="category"
                    :items="categories"
                    label="Categoría de Proyecto"
                    placeholder="Selecciona una categoría"
                    outlined
                    dense
                    class="mb-6"
                ></v-select>
                <!-- Checkboxes -->
                <div class="mb-2 font-weight-medium">Checkboxes</div>
                <v-checkbox
                    v-model="notifications"
                    label="Recibir notificaciones"
                    color="deep-purple accent-4"
                    hide-details
                    class="mb-1"
                ></v-checkbox>
                <v-checkbox
                    v-model="productUpdates"
                    label="Actualizaciones de producto"
                    color="deep-purple accent-4"
                    hide-details
                ></v-checkbox>
            </v-col>

            <!-- Right Column -->
            <v-col cols="12" md="6">
                <!-- Error Field -->
                <div class="mb-6">
                    <div class="font-weight-medium mb-1">Campo con Error</div>
                    <v-text-field
                        value=""
                        label=""
                        placeholder="Campo requerido"
                        outlined
                        dense
                        :error="true"
                        class="mb-1"
                        hide-details
                        style="border-color: #ff5252;"
                    ></v-text-field>
                    <div class="caption red--text d-flex align-center" style="margin-left: 10px;">
                        <v-icon small color="red" class="mr-1">mdi-alert-circle-outline</v-icon>
                        Este campo es requerido
                    </div>
                </div>
                <!-- Valid Field -->
                <div class="mb-6">
                    <div class="font-weight-medium mb-1">Campo Válido</div>
                    <v-text-field
                        value="sincarbono@example.com"
                        label=""
                        outlined
                        dense
                        success
                        class="mb-1"
                        style="border-color: #4caf50;"
                        hide-details
                    ></v-text-field>
                    <div class="caption green--text d-flex align-center" style="margin-left: 10px;">
                        <v-icon small color="green" class="mr-1">mdi-check-circle-outline</v-icon>
                        Email válido
                    </div>
                </div>
                <!-- Disabled Field -->
                <div class="mb-8">
                    <div class="font-weight-medium mb-1 grey--text text--darken-1">Campo Deshabilitado</div>
                    <v-text-field
                        value="No disponible"
                        label=""
                        outlined
                        dense
                        disabled
                        class="mb-1"
                        hide-details
                    ></v-text-field>
                </div>

                <!-- Radio Buttons -->
                <div class="mb-4 font-weight-medium">Radio Buttons</div>
                <v-radio-group v-model="radio" class="mb-6">
                    <v-radio
                        label="Email"
                        value="email"
                        color="deep-purple accent-4"
                    ></v-radio>
                    <v-radio
                        label="SMS"
                        value="sms"
                        color="deep-purple accent-4"
                    ></v-radio>
                    <v-radio
                        label="Push Notifications"
                        value="push"
                        color="deep-purple accent-4"
                    ></v-radio>
                </v-radio-group>

                <!-- Switch -->
                <div class="mb-2 font-weight-medium">Modo oscuro</div>
                <v-switch
                    v-model="darkMode"
                    color="deep-purple accent-4"
                    hide-details
                    class="mb-6"
                ></v-switch>

                <!-- Slider -->
                <div class="mb-1 font-weight-medium">Objetivo reducción: {{ slider }}%</div>
                <v-slider
                    v-model="slider"
                    color="deep-purple accent-4"
                    track-color="grey lighten-3"
                    min="0"
                    max="100"
                    step="1"
                    thumb-label
                    height="25"
                ></v-slider>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: "Forms",
    data() {
        return {
            email: "",
            password: "",
            showPassword: false,
            search: "",
            category: null,
            categories: [
                "Energía",
                "Transporte",
                "Agricultura",
                "Tecnología",
                "Educación"
            ],
            notifications: false,
            productUpdates: true,
            radio: "email",
            darkMode: false,
            slider: 75
        };
    }
};
</script>

<style scoped>
.font-weight-medium {
    font-weight: 500;
}
</style>